import React from "react";
import { Route, Routes } from "react-router-dom";
import Aboutus from "./components/navbar/about-us";
import RefundPolicy from "./components/navbar/refund-policy";
import PrivacyPolicy from "./components/navbar/privacy-policy";
import Pricing from "./components/navbar/pricing";
import ContactUs from "./components/navbar/contact";
import TermsAndConditions from "./components/navbar/terms-and-condition";
import Landingpage from "./landingpage";
import Callback from "./components/callback";
import Login from "./components/login";
import SignUp from "./components/navbar/sign-up";
import UserDashboard from "./components/navbar/user-dashboard";

function Routing() {
  return (
    <Routes>
      <Route path="/" element={<Landingpage />} />
      <Route path="/about-us" element={<Aboutus />} />
      <Route path="/refunds" element={<RefundPolicy />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/contact-us" element={<ContactUs />} />
      {/* <Route path="/sign-in" element={<SignIn />} /> */}
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/login" element={<Login />} />
      <Route path="/account" element={<UserDashboard />} />
      {/* <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/forgot" element={<ForgotPassword />} /> */}
    </Routes>
  );
}

export default Routing;
